import { Theme } from '@mui/material/styles';

import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles<Theme>()((theme) => ({
  filesWrapper: {
    display: 'flex',
    gap: 8,
  },
  filesContainerPageWrapper: {
    width: '100%',
    overflowX: 'auto',
    display: 'flex',
  },
  /** WKWebView (iOS / Capacitor): `display:none` on file inputs often breaks the picker. */
  fileInputOverlay: {
    position: 'absolute',
    inset: 0,
    width: '100%',
    height: '100%',
    margin: 0,
    padding: 0,
    opacity: 0,
    cursor: 'pointer',
    zIndex: 1,
    fontSize: 0,
  },
  uploadTrigger: {
    position: 'relative',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100px',
    minHeight: '100px',
  },
  uploadFileLabel: {
    height: '100px',
    minHeight: '100px',
    cursor: 'pointer',
    color: theme.palette.text.primary,
  },

  file: {
    border: '1px solid transparent',
    borderRadius: '10px',
    overflow: 'hidden',
    position: 'relative',
  },
  mainFileLabel: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.common.white,
    padding: '2px 4px',
    borderTopLeftRadius: '4px',
    position: 'absolute',
    bottom: 0,
    right: 0,
    zIndex: 1,
  },
  mainFile: {
    border: `1px solid ${theme.palette.primary.main}`,
  },
}));
